const message = {
  select: 'Select',
  registerAsEmployer: 'Register as Employer',
  registerAsEmployee: 'Register as Employee',
  employee: 'Employee',
  employees: 'Employees',
  employer: 'Employer',
  calendar: 'Calendar',
  schedule: 'Schedule',
  works: 'Works',
  settings: 'Settings',
  feedback: 'Feedback',
  manage: 'Manage',
  skills: 'Skills',
  search: 'Search',
  tasks: 'Tasks',
  deleteAccount: 'Delete Account',
  home: 'Home'
};
export default message;
